/*
 * Marketing API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.26
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {EmailActivity} from './EmailActivity';

/**
 * The InlineResponse2016 model module.
 * @module model/InlineResponse2016
 * @version 1.0.0
 */
export class InlineResponse2016 {
  /**
   * Constructs a new <code>InlineResponse2016</code>.
   * @alias module:model/InlineResponse2016
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>InlineResponse2016</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/InlineResponse2016} obj Optional instance to populate.
   * @return {module:model/InlineResponse2016} The populated <code>InlineResponse2016</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new InlineResponse2016();
      if (data.hasOwnProperty('data'))
        obj.data = EmailActivity.constructFromObject(data['data']);
    }
    return obj;
  }
}

/**
 * @member {module:model/EmailActivity} data
 */
InlineResponse2016.prototype.data = undefined;

